import { Component, forwardRef, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'oneui-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.css'],
  providers: [
    { provide: MatFormFieldControl, useExisting: FileInputComponent },
  ]
})
export class FileInputComponent implements MatFormFieldControl<File | null>, ControlValueAccessor {
  @Input()
  public id: string = "";
  @Input()
  public placeholder: string = "";
  @Input()
  public value: File | null = null;
  @Input()
  public focused: boolean = false;
  @Input()
  public required: boolean = true;
  @Input()
  public disabled: boolean = false;

  public shouldLabelFloat: boolean = false;
  public errorState: boolean = false;
  public autofilled: boolean = false;
  public empty: boolean = true;

  public controlType?: string;
  public userAriaDescribedBy?: string;

  readonly stateChanges: Subject<void> = new Subject<void>();

  private ids: string[] = [];
  public onChange: any;
  public onTouch: any;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  get filename(): string {
    if (this.value) {
      return this.value.name;
    }
    return "Nenhum arquivo selecionado";
  }

  writeValue(obj: File): void {
    console.log(obj);
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDescribedByIds(ids: string[]): void {
    this.ids = ids;
  }
  onContainerClick(event: MouseEvent): void {
    console.log("ContainerClick", event);
  }

  public selectFile(event: Event): void {
    let fileInput = event.target as HTMLInputElement;
    if (fileInput.files == null) {
      return;
    }
    for (const file of Array.from(fileInput.files)) {
      console.log(file);
      this.writeValue(file);
      this.onChange(file);
      this.stateChanges.next();
    }
  }
}
